<template name="dialog-remove">
	<div class="remove-media-dialog">
		<el-dialog
		  title="批量移动"
		  :visible.sync="show"
		  :before-close="close"
		  :close-on-click-modal="false"
		>
			<el-form :model="ruleForm" ref="ruleForm" label-width="80px">
				<div style="font-size: 14px;color: #333333;margin-bottom: 15px;margin-left: 12px;">将已选{{media_ids.length}}项素材移动至</div>
				<el-form-item label="" prop="category_id" v-if="category.length > 0" style="margin-bottom: 10px;">
					<el-cascader class="scene-in" v-model="ruleForm.category_id" :options="category" :props="props" :show-all-levels="true" placeholder="选择分组">
					  <template slot-scope="{ node, data }">
						<span>{{ data.label }}</span>
						<span v-if="!node.isLeaf">  ({{ data.children.length }}) </span>
					  </template>
					</el-cascader> 
				</el-form-item>
				<div style="font-size: 12px;color: #999999;margin-top: 10px;margin-left: 12px;">从归属的所有分组中移出，移动到新分组中</div>
			</el-form>
			
			<div slot="footer">
				<el-button type="primary" @click="confirm">确认保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAllCategory,
		getRelationChain
	} from '@/api/depot_category';
	import {
		batchMove
	} from '@/api/depot_media.js';
	
	export default {
		data() {
			return {
				is_submit: false,
				ruleForm: {
					category_id: [0],
				},
				
				category: [],
				props: {
					checkStrictly: true
				}
			};
		},
		props: {
			media_ids: {
				type: Array,
				default: []
			},
			type:{
				type: Number,
				default: 1
			},
			// cate: {
			// 	type: Array,
			// 	default: [0]
			// },
			show: {
				type: Boolean,
				default: false
			}
		},
		watch:{
			show: function(newVal, oldVal){
				if(newVal){
					this.ruleForm.category_id = this.cate
					this.getCategory();
				}
			}
		},
		methods: {
			_reset(){
				this.is_submit = false;
				this.ruleForm.category_id = ''
				this.category = [];
				this.$refs['ruleForm'].resetFields();
			},
			getCategory() {
				var that = this;
				getAllCategory({
					type: that.type
				}).then(res => {
					if (res.code == 0) {
						this.category = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			close() {
				this._reset();
				this.$emit('close');
			},
			confirm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						if (this.is_submit) {
							return false;
						}
						
						console.log(this.ruleForm.category_id);
						if(!this.ruleForm.category_id){
							this.$message.error('请选择分组');
							return;
						}
						this.is_submit = true;
						var category_id = this.ruleForm.category_id[this.ruleForm.category_id.length - 1];
						
						batchMove({
							media_ids: this.media_ids,
							category_id: category_id
						}).then(res => {
							if (res.code == 0) {
								this.$message.success(res.message);
								this._reset();
								this.$emit('success');
							} else {
								this.is_submit = false;
								this.$message.error(res.message);
							}
						})
					}
				})
						
				
			}
		},
		mounted() {}
	}
</script>

<style scoped>
	.remove-media-dialog >>> .el-dialog {
		width: 424px;
	}
	.remove-media-dialog >>> .el-form-item__content{
		margin-left: 12px !important;
	}
	.remove-media-dialog .gp-textarea textarea {
		height: 100px;
	}
	.remove-media-dialog .el-dialog__footer {
		padding-top: 20px;
	}
	.scene-in{
		width: 360px;
	}
</style>
